import React from 'react';
import Header from './Header';
import Navbar from './Navbar';
import Footer from './Footer';
import PreviewBanner from './PreviewBanner';
import Breadcrumbs from './Breadcrumbs';
import SetupWizard from './SetupWizard';

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col">
      <SetupWizard />
      <PreviewBanner />
      <Header />
      <Navbar />
      <Breadcrumbs />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
